import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'print-button',
    templateUrl: './button.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrintButton {

    @Output()
    notifyOpen: EventEmitter<boolean> = new EventEmitter();

    @Input()
    buttonText: string = null;

    printViewShown = false;

    open(doOpen: boolean): void {
        this.printViewShown = doOpen;
        this.notifyOpen.emit(doOpen);
    }

}

